// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27%2364748b%27%3E%3Cpath d=%27M4 6a2 2 0 012-2h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6zm2 0v12h12V6H6zm4 2a1 1 0 011 1v6a1 1 0 11-2 0V9a1 1 0 011-1zm4 0a1 1 0 011 1v6a1 1 0 11-2 0V9a1 1 0 011-1z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Bulk Upload Page Styles - Consistent with Design System */

.bulk-upload-page {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
  padding: 0;
}

/* Back Button Container - Top */
.back-button-container {
  margin-bottom: 0.5rem;
}

/* Back Button */
.back-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  color: var(--text-sub);
  font-size: 0.875rem;
  font-weight: 600;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-full);
  cursor: pointer;
  transition: all var(--transition-fast);
  background: var(--surface-light);
}

.back-btn:hover {
  background: var(--slate-50);
  color: var(--text-main);
  border-color: var(--slate-300);
}

.back-btn .material-symbols-outlined {
  font-size: 18px;
}

/* Page Header */
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 0;
}

.page-header .header-content {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.page-header .page-title {
  font-size: 1.875rem;
  font-weight: 900;
  color: var(--text-main);
  margin: 0;
  letter-spacing: -0.02em;
}

.page-header .page-subtitle {
  font-size: 0.875rem;
  color: var(--text-sub);
  margin: 0;
}

/* Filters Bar */
.filters-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem;
  background-color: var(--surface-light);
  border-radius: var(--radius-xl);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-sm);
  flex-wrap: wrap;
}

.filter-tabs {
  display: flex;
  gap: 0.25rem;
  padding: 0.25rem;
  background-color: var(--slate-100);
  border-radius: var(--radius-lg);
}

.filter-tab {
  padding: 0.375rem 1rem;
  border-radius: var(--radius-md);
  background: transparent;
  border: none;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--text-sub);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.filter-tab:hover {
  color: var(--text-main);
}

.filter-tab.active {
  background-color: var(--surface-light);
  color: var(--text-main);
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

/* Upload Cards Grid */
.uploads-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(450px, 1fr));
  gap: 1.5rem;
  margin-top: 0.5rem;
}

.upload-card {
  background: var(--surface-light);
  border-radius: var(--radius-xl);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
  transition: transform 0.2s, box-shadow 0.2s;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}

.upload-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
  border-color: var(--primary);
}

.upload-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem;
  background: var(--slate-50);
  color: var(--text-main);
  flex-shrink: 0;
  border-bottom: 1px solid var(--border-color);
}

.upload-id {
  font-size: 0.875rem;
  font-weight: 600;
  opacity: 0.95;
}

.upload-card-body {
  padding: 1.25rem;
  flex: 1 1;
}

.upload-images {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 1rem;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 0;
}

.image-wrapper label {
  font-size: 0.6875rem;
  font-weight: 600;
  color: var(--text-sub);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.barcode-image,
.cover-image {
  width: 100%;
  height: 200px;
  object-fit: contain;
  border-radius: var(--radius-lg);
  background: var(--slate-50);
  border: 1px solid var(--border-color);
}

/* Clickable images in detail modal */
.image-section img.clickable,
.book-cover-detail.clickable {
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.image-section img.clickable:hover,
.book-cover-detail.clickable:hover {
  transform: scale(1.03);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Book cover inline - same as Books table */
.book-cover-inline {
  width: 48px;
  height: 64px;
  object-fit: cover;
  border-radius: var(--radius-md);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  border: 1px solid var(--border-color);
}

.book-cover-placeholder-inline {
  width: 48px;
  height: 64px;
  border-radius: var(--radius-md);
  border: 1px solid var(--border-color);
  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 24px;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.book-cover-placeholder-inline .material-symbols-outlined {
  font-size: 24px;
  color: #64748b;
}

/* Book cover placeholder for bulk upload cards (large) */
.book-cover-placeholder-large-card {
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);
  color: #1e293b;
  padding: 1rem;
  text-align: center;
  border-radius: var(--radius-lg);
  border: 1px solid var(--border-color);
  box-sizing: border-box;
}

.book-cover-placeholder-large-card .placeholder-large-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
}

.book-cover-placeholder-large-card .placeholder-large-title {
  font-size: 0.95rem;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  word-break: break-word;
}

.book-cover-placeholder-large-card .placeholder-large-author {
  font-size: 0.75rem;
  font-weight: 500;
  color: #64748b;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Book cover for detail modal - larger size */
.book-cover-detail {
  width: 120px;
  height: 160px;
  object-fit: cover;
  border-radius: var(--radius-lg);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  border: 1px solid var(--border-color);
}

.book-cover-placeholder-detail {
  width: 120px;
  height: 160px;
  border-radius: var(--radius-lg);
  border: 1px solid var(--border-color);
  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 48px;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.book-cover-placeholder-detail .material-symbols-outlined {
  font-size: 48px;
  color: #64748b;
}

.upload-details {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
}

.upload-title {
  font-size: 1.0625rem;
  font-weight: 600;
  color: var(--text-main);
  margin: 0;
}

.upload-author {
  font-size: 0.875rem;
  color: var(--text-sub);
  margin: 0;
}

.upload-isbn,
.upload-category,
.upload-publisher,
.upload-year,
.upload-description,
.upload-date {
  font-size: 0.875rem;
  color: var(--text-main);
  margin: 0;
}

.upload-description {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.5;
}

.admin-comment {
  background: var(--warning-bg);
  border-left: 3px solid var(--warning-border);
  padding: 0.75rem;
  border-radius: var(--radius-md);
  font-size: 0.8125rem;
  margin-top: 0.5rem;
}

.admin-comment strong {
  display: block;
  color: var(--warning-text);
  margin-bottom: 0.25rem;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.admin-comment p {
  margin: 0;
  color: var(--warning-text);
}

.upload-card-actions {
  display: flex;
  flex-wrap: nowrap;
  gap: 0.5rem;
  padding: 1rem 1.25rem;
  background: transparent;
  border-top: 1px solid var(--border-color);
  justify-content: flex-end;
  flex-shrink: 0;
}

.upload-card-actions .btn {
  flex-shrink: 0;
  white-space: nowrap;
}

.upload-card-actions-error {
  display: flex;
  flex-wrap: nowrap;
  gap: 0.5rem;
  align-items: center;
}

/* Status Badges */
.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  border-radius: var(--radius-full);
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border: 1px solid;
}

.status-pending {
  background: var(--warning-bg);
  color: var(--warning-text);
  border-color: var(--warning-border);
}

.status-approved {
  background: var(--success-bg);
  color: var(--success-text);
  border-color: var(--success-border);
}

.status-rejected {
  background: var(--error-bg);
  color: var(--error-text);
  border-color: var(--error-border);
}

.status-error {
  background: var(--error-bg);
  color: var(--error-text);
  border-color: var(--error-border);
}

.status-fixed {
  background: var(--success-bg);
  color: var(--success-text);
  border-color: var(--success-border);
}

/* Error Message Section */
.error-message-section {
  background: var(--error-bg);
  border-left: 3px solid var(--error-border);
  padding: 0.75rem;
  border-radius: var(--radius-md);
  font-size: 0.8125rem;
  margin-top: 0.5rem;
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
}

.error-message-section.detail {
  margin-top: 0.75rem;
  padding: 1rem;
}

.error-message-section .error-icon {
  color: var(--error-text);
  font-size: 1.25rem;
  flex-shrink: 0;
}

.error-message-section strong {
  display: block;
  color: var(--error-text);
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  white-space: nowrap;
}

.error-message-section .error-text {
  margin: 0;
  color: var(--error-text);
  line-height: 1.5;
  flex: 1 1;
}

.error-message-section.detail strong {
  display: inline;
  margin-right: 0.5rem;
}

.error-message-section.detail .error-text {
  display: block;
  margin-top: 0.25rem;
}

/* Empty State */
.empty-state-card {
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  text-align: center;
  color: var(--text-sub);
  background: var(--surface-light);
  border-radius: var(--radius-xl);
  border: 1px solid var(--border-color);
}

.empty-state-card .material-symbols-outlined {
  font-size: 4rem;
  margin-bottom: 1rem;
  opacity: 0.5;
}

.empty-state-card h3 {
  font-size: 1.125rem;
  color: var(--text-main);
  margin: 0 0 0.5rem 0;
}

.empty-state-card p {
  margin: 0;
  font-size: 0.875rem;
}

/* Detail Modal */
.bulk-upload-detail-modal {
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
  border-radius: var(--radius-xl);
}

.bulk-upload-detail-modal .modal-header {
  border-bottom: 1px solid var(--border-color);
  padding: 1.25rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.bulk-upload-detail-modal .modal-title {
  color: var(--text-main);
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0;
}

.bulk-upload-detail-modal .modal-close {
  color: var(--text-sub);
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-md);
  transition: all var(--transition-fast);
}

.bulk-upload-detail-modal .modal-close:hover {
  background: var(--slate-100);
  color: var(--text-main);
}

.bulk-upload-detail-modal .modal-body {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 1.5rem;
}

.detail-images {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
}

.image-section {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.image-section label {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-sub);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.image-section img {
  width: 120px;
  height: 160px;
  object-fit: cover;
  border-radius: var(--radius-lg);
  background: var(--slate-50);
  border: 1px solid var(--border-color);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
}

.detail-info {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.detail-info h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--text-main);
  margin: 0;
}

.detail-info p {
  font-size: 0.875rem;
  color: var(--text-sub);
  margin: 0;
}

.description-section {
  margin-top: 0.5rem;
}

.description-section strong {
  display: block;
  font-size: 0.875rem;
  color: var(--text-main);
  margin-bottom: 0.5rem;
}

.description-section p {
  line-height: 1.6;
}

.admin-comment-section {
  background: var(--warning-bg);
  border-left: 3px solid var(--warning-border);
  padding: 1rem;
  border-radius: var(--radius-md);
}

.admin-comment-section strong {
  display: block;
  color: var(--warning-text);
  margin-bottom: 0.5rem;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.admin-comment-section p {
  margin: 0;
  color: var(--warning-text);
  line-height: 1.5;
}

.bulk-upload-detail-modal .modal-actions {
  display: flex;
  flex-direction: row;
  gap: 0.75rem;
  padding: 1rem 1.5rem 1.5rem;
  border-top: 1px solid var(--border-color);
  justify-content: flex-end;
  flex-shrink: 0;
}

.bulk-upload-detail-modal .modal-actions .btn {
  white-space: nowrap;
}

/* Comment Modal */
.comment-modal-overlay {
  backdrop-filter: blur(4px);
}

.comment-modal {
  border-radius: var(--radius-xl);
  max-width: 500px;
}

.comment-modal .modal-header {
  border-bottom: 1px solid var(--border-color);
  padding: 1.25rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.comment-modal .modal-title {
  color: var(--text-main);
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0;
}

.comment-modal .modal-close {
  color: var(--text-sub);
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-md);
  transition: all var(--transition-fast);
}

.comment-modal .modal-close:hover {
  background: var(--slate-100);
  color: var(--text-main);
}

.comment-modal .modal-body {
  padding: 1.5rem;
}

.comment-modal .modal-message {
  font-size: 0.9375rem;
  color: var(--text-main);
  margin-bottom: 1rem;
}

.comment-input-wrapper {
  width: 100%;
  margin-bottom: 1rem;
}

.comment-input-wrapper label {
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-main);
  margin-bottom: 0.5rem;
}

.comment-input-wrapper .form-textarea {
  width: 100%;
}

/* Edit Modal */
.bulk-upload-edit-modal {
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  border-radius: var(--radius-xl);
}

.bulk-upload-edit-modal .modal-header {
  border-bottom: 1px solid var(--border-color);
  padding: 1.25rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.bulk-upload-edit-modal .modal-title {
  color: var(--text-main);
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0;
}

.bulk-upload-edit-modal .modal-close {
  color: var(--text-sub);
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-md);
  transition: all var(--transition-fast);
}

.bulk-upload-edit-modal .modal-close:hover {
  background: var(--slate-100);
  color: var(--text-main);
}

.bulk-upload-edit-modal .modal-body {
  padding: 1.5rem;
}

.edit-form {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.edit-form .form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.edit-form .form-group.full-width {
  grid-column: 1 / -1;
}

.edit-form .form-group label {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-main);
}

.edit-form .form-group .form-input,
.edit-form .form-group .form-textarea {
  width: 100%;
  padding: 0.625rem 0.75rem;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  font-family: inherit;
  font-size: 0.875rem;
  transition: border-color 0.2s;
  background-color: var(--surface-light);
}

.edit-form .form-group .form-input:focus,
.edit-form .form-group .form-textarea:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px var(--primary-light);
}

.edit-form .form-group .form-textarea {
  resize: vertical;
  min-height: 100px;
}

/* Responsive */
@media (max-width: 768px) {
  .bulk-upload-page {
    padding: 1rem;
  }

  .uploads-grid {
    grid-template-columns: 1fr;
  }

  .upload-images {
    grid-template-columns: 1fr;
  }

  .detail-images {
    grid-template-columns: 1fr;
  }

  .page-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .upload-card-actions {
    justify-content: stretch;
  }

  .upload-card-actions .btn {
    flex: 1 1;
    justify-content: center;
  }

  .bulk-upload-detail-modal .modal-actions {
    flex-direction: column;
  }

  .bulk-upload-detail-modal .modal-actions .btn {
    width: 100%;
  }

  .filter-tabs {
    width: 100%;
  }

  .filter-tab {
    flex: 1 1;
    text-align: center;
  }

  .page-header .page-title {
    font-size: 1.5rem;
  }
}

/* Pagination */
.pagination-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem 0;
  border-top: 1px solid var(--border-color);
  margin-top: 1rem;
}

.pagination-info {
  font-size: 0.875rem;
  color: var(--text-sub);
  margin: 0;
}

.pagination-info strong {
  color: var(--text-main);
  font-weight: 600;
}

.pagination-buttons {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.page-indicator {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-main);
  padding: 0 1rem;
}

/* Responsive */
@media (max-width: 768px) {
  .pagination-container {
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .pagination-buttons {
    flex: 1 1;
    justify-content: center;
  }

  .page-indicator {
    padding: 0 0.5rem;
  }
}

/* Image Preview Modal */
.image-preview-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 2rem;
  animation: fade-in 0.2s ease-out;
}

@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.image-preview-modal {
  background: var(--surface);
  border-radius: var(--radius-xl);
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.image-preview-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid var(--border-color);
}

.image-preview-header h3 {
  margin: 0;
  font-size: 1.125rem;
  color: var(--text-main);
  font-weight: 600;
}

.image-preview-header .modal-close {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: var(--radius-md);
  color: var(--text-sub);
  transition: all var(--transition-fast);
}

.image-preview-header .modal-close:hover {
  background: var(--slate-100);
  color: var(--text-main);
}

.image-preview-content {
  padding: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
  min-height: 400px;
  max-height: 70vh;
  overflow: auto;
}

.image-preview-content img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.image-preview-footer {
  display: flex;
  gap: 0.75rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid var(--border-color);
  background: var(--surface);
}

.image-preview-footer .btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

/* Zoom Controls */
.zoom-controls {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.zoom-btn {
  background: transparent;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--text-sub);
  transition: all var(--transition-fast);
}

.zoom-btn:hover {
  background: var(--slate-100);
  color: var(--text-main);
  border-color: var(--slate-300);
}

.zoom-btn.reset {
  margin-left: 0.5rem;
}

.zoom-level {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-main);
  min-width: 50px;
  text-align: center;
}

.image-preview-content img {
  transition: transform 0.2s ease-out;
  transform-origin: center center;
}

@media (max-width: 480px) {
  .upload-card-actions .btn {
    flex: 1 1 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/BulkUploadPage.css"],"names":[],"mappings":"AAAA,4DAA4D;;AAE5D;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,UAAU;AACZ;;AAEA,gCAAgC;AAChC;EACE,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;EACf,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,sCAAsC;EACtC,+BAA+B;EAC/B,qCAAqC;EACrC,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,qCAAqC;EACrC,4BAA4B;EAC5B,gBAAgB;EAChB,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,uBAAuB;EACvB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA,qCAAqC;AACrC;;EAEE,eAAe;EACf,2CAA2C;AAC7C;;AAEA;;EAEE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA,4CAA4C;AAC5C;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,qCAAqC;EACrC,6DAA6D;EAC7D,yDAAmU;EACnU,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,yDAAyD;AACzD;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,+BAA+B;EAC/B,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,qCAAqC;EACrC,6DAA6D;EAC7D,yDAAmU;EACnU,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;AACX;;AAEA;;;;;;EAME,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,4CAA4C;EAC5C,gBAAgB;EAChB,+BAA+B;EAC/B,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,qBAAqB;EACrB,uBAAuB;EACvB,yCAAyC;EACzC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA,0BAA0B;AAC1B;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,gBAAgB;EAChB,+BAA+B;EAC/B,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,gCAAgC;EAChC,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,4CAA4C;EAC5C,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;EAC3B,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,4CAA4C;EAC5C,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,yCAAyC;EACzC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,4CAA4C;EAC5C,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qCAAqC;EACrC,+BAA+B;EAC/B,oBAAoB;EACpB,mBAAmB;EACnB,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;;EAEE,aAAa;EACb,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,SAAO;IACP,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;IACP,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,eAAe;AACf;EACE;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,+BAA+B;EAC/B,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":["/* Bulk Upload Page Styles - Consistent with Design System */\n\n.bulk-upload-page {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  max-width: 1400px;\n  margin: 0 auto;\n  width: 100%;\n  padding: 0;\n}\n\n/* Back Button Container - Top */\n.back-button-container {\n  margin-bottom: 0.5rem;\n}\n\n/* Back Button */\n.back-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  color: var(--text-sub);\n  font-size: 0.875rem;\n  font-weight: 600;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-full);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  background: var(--surface-light);\n}\n\n.back-btn:hover {\n  background: var(--slate-50);\n  color: var(--text-main);\n  border-color: var(--slate-300);\n}\n\n.back-btn .material-symbols-outlined {\n  font-size: 18px;\n}\n\n/* Page Header */\n.page-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  flex-wrap: wrap;\n  margin-bottom: 0;\n}\n\n.page-header .header-content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.page-header .page-title {\n  font-size: 1.875rem;\n  font-weight: 900;\n  color: var(--text-main);\n  margin: 0;\n  letter-spacing: -0.02em;\n}\n\n.page-header .page-subtitle {\n  font-size: 0.875rem;\n  color: var(--text-sub);\n  margin: 0;\n}\n\n/* Filters Bar */\n.filters-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1rem;\n  background-color: var(--surface-light);\n  border-radius: var(--radius-xl);\n  border: 1px solid var(--border-color);\n  box-shadow: var(--shadow-sm);\n  flex-wrap: wrap;\n}\n\n.filter-tabs {\n  display: flex;\n  gap: 0.25rem;\n  padding: 0.25rem;\n  background-color: var(--slate-100);\n  border-radius: var(--radius-lg);\n}\n\n.filter-tab {\n  padding: 0.375rem 1rem;\n  border-radius: var(--radius-md);\n  background: transparent;\n  border: none;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--text-sub);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.filter-tab:hover {\n  color: var(--text-main);\n}\n\n.filter-tab.active {\n  background-color: var(--surface-light);\n  color: var(--text-main);\n  font-weight: 600;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n/* Upload Cards Grid */\n.uploads-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(450px, 1fr));\n  gap: 1.5rem;\n  margin-top: 0.5rem;\n}\n\n.upload-card {\n  background: var(--surface-light);\n  border-radius: var(--radius-xl);\n  border: 1px solid var(--border-color);\n  box-shadow: var(--shadow-sm);\n  overflow: hidden;\n  transition: transform 0.2s, box-shadow 0.2s;\n  display: flex;\n  flex-direction: column;\n  cursor: pointer;\n}\n\n.upload-card:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n  border-color: var(--primary);\n}\n\n.upload-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 1.25rem;\n  background: var(--slate-50);\n  color: var(--text-main);\n  flex-shrink: 0;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.upload-id {\n  font-size: 0.875rem;\n  font-weight: 600;\n  opacity: 0.95;\n}\n\n.upload-card-body {\n  padding: 1.25rem;\n  flex: 1;\n}\n\n.upload-images {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.image-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  min-width: 0;\n}\n\n.image-wrapper label {\n  font-size: 0.6875rem;\n  font-weight: 600;\n  color: var(--text-sub);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.barcode-image,\n.cover-image {\n  width: 100%;\n  height: 200px;\n  object-fit: contain;\n  border-radius: var(--radius-lg);\n  background: var(--slate-50);\n  border: 1px solid var(--border-color);\n}\n\n/* Clickable images in detail modal */\n.image-section img.clickable,\n.book-cover-detail.clickable {\n  cursor: pointer;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.image-section img.clickable:hover,\n.book-cover-detail.clickable:hover {\n  transform: scale(1.03);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n/* Book cover inline - same as Books table */\n.book-cover-inline {\n  width: 48px;\n  height: 64px;\n  object-fit: cover;\n  border-radius: var(--radius-md);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n  border: 1px solid var(--border-color);\n}\n\n.book-cover-placeholder-inline {\n  width: 48px;\n  height: 64px;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border-color);\n  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%2364748b'%3E%3Cpath d='M4 6a2 2 0 012-2h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6zm2 0v12h12V6H6zm4 2a1 1 0 011 1v6a1 1 0 11-2 0V9a1 1 0 011-1zm4 0a1 1 0 011 1v6a1 1 0 11-2 0V9a1 1 0 011-1z'/%3E%3C/svg%3E\");\n  background-size: 24px;\n  background-repeat: no-repeat;\n  background-position: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.book-cover-placeholder-inline .material-symbols-outlined {\n  font-size: 24px;\n  color: #64748b;\n}\n\n/* Book cover placeholder for bulk upload cards (large) */\n.book-cover-placeholder-large-card {\n  width: 100%;\n  height: 200px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);\n  color: #1e293b;\n  padding: 1rem;\n  text-align: center;\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--border-color);\n  box-sizing: border-box;\n}\n\n.book-cover-placeholder-large-card .placeholder-large-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  width: 100%;\n}\n\n.book-cover-placeholder-large-card .placeholder-large-title {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #1e293b;\n  line-height: 1.3;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n  word-break: break-word;\n}\n\n.book-cover-placeholder-large-card .placeholder-large-author {\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: #64748b;\n  line-height: 1.4;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* Book cover for detail modal - larger size */\n.book-cover-detail {\n  width: 120px;\n  height: 160px;\n  object-fit: cover;\n  border-radius: var(--radius-lg);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);\n  border: 1px solid var(--border-color);\n}\n\n.book-cover-placeholder-detail {\n  width: 120px;\n  height: 160px;\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--border-color);\n  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%2364748b'%3E%3Cpath d='M4 6a2 2 0 012-2h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6zm2 0v12h12V6H6zm4 2a1 1 0 011 1v6a1 1 0 11-2 0V9a1 1 0 011-1zm4 0a1 1 0 011 1v6a1 1 0 11-2 0V9a1 1 0 011-1z'/%3E%3C/svg%3E\");\n  background-size: 48px;\n  background-repeat: no-repeat;\n  background-position: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.book-cover-placeholder-detail .material-symbols-outlined {\n  font-size: 48px;\n  color: #64748b;\n}\n\n.upload-details {\n  display: flex;\n  flex-direction: column;\n  gap: 0.375rem;\n}\n\n.upload-title {\n  font-size: 1.0625rem;\n  font-weight: 600;\n  color: var(--text-main);\n  margin: 0;\n}\n\n.upload-author {\n  font-size: 0.875rem;\n  color: var(--text-sub);\n  margin: 0;\n}\n\n.upload-isbn,\n.upload-category,\n.upload-publisher,\n.upload-year,\n.upload-description,\n.upload-date {\n  font-size: 0.875rem;\n  color: var(--text-main);\n  margin: 0;\n}\n\n.upload-description {\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  line-height: 1.5;\n}\n\n.admin-comment {\n  background: var(--warning-bg);\n  border-left: 3px solid var(--warning-border);\n  padding: 0.75rem;\n  border-radius: var(--radius-md);\n  font-size: 0.8125rem;\n  margin-top: 0.5rem;\n}\n\n.admin-comment strong {\n  display: block;\n  color: var(--warning-text);\n  margin-bottom: 0.25rem;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.admin-comment p {\n  margin: 0;\n  color: var(--warning-text);\n}\n\n.upload-card-actions {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 0.5rem;\n  padding: 1rem 1.25rem;\n  background: transparent;\n  border-top: 1px solid var(--border-color);\n  justify-content: flex-end;\n  flex-shrink: 0;\n}\n\n.upload-card-actions .btn {\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n.upload-card-actions-error {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n/* Status Badges */\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.25rem 0.75rem;\n  border-radius: var(--radius-full);\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border: 1px solid;\n}\n\n.status-pending {\n  background: var(--warning-bg);\n  color: var(--warning-text);\n  border-color: var(--warning-border);\n}\n\n.status-approved {\n  background: var(--success-bg);\n  color: var(--success-text);\n  border-color: var(--success-border);\n}\n\n.status-rejected {\n  background: var(--error-bg);\n  color: var(--error-text);\n  border-color: var(--error-border);\n}\n\n.status-error {\n  background: var(--error-bg);\n  color: var(--error-text);\n  border-color: var(--error-border);\n}\n\n.status-fixed {\n  background: var(--success-bg);\n  color: var(--success-text);\n  border-color: var(--success-border);\n}\n\n/* Error Message Section */\n.error-message-section {\n  background: var(--error-bg);\n  border-left: 3px solid var(--error-border);\n  padding: 0.75rem;\n  border-radius: var(--radius-md);\n  font-size: 0.8125rem;\n  margin-top: 0.5rem;\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n}\n\n.error-message-section.detail {\n  margin-top: 0.75rem;\n  padding: 1rem;\n}\n\n.error-message-section .error-icon {\n  color: var(--error-text);\n  font-size: 1.25rem;\n  flex-shrink: 0;\n}\n\n.error-message-section strong {\n  display: block;\n  color: var(--error-text);\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  white-space: nowrap;\n}\n\n.error-message-section .error-text {\n  margin: 0;\n  color: var(--error-text);\n  line-height: 1.5;\n  flex: 1;\n}\n\n.error-message-section.detail strong {\n  display: inline;\n  margin-right: 0.5rem;\n}\n\n.error-message-section.detail .error-text {\n  display: block;\n  margin-top: 0.25rem;\n}\n\n/* Empty State */\n.empty-state-card {\n  grid-column: 1 / -1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 2rem;\n  text-align: center;\n  color: var(--text-sub);\n  background: var(--surface-light);\n  border-radius: var(--radius-xl);\n  border: 1px solid var(--border-color);\n}\n\n.empty-state-card .material-symbols-outlined {\n  font-size: 4rem;\n  margin-bottom: 1rem;\n  opacity: 0.5;\n}\n\n.empty-state-card h3 {\n  font-size: 1.125rem;\n  color: var(--text-main);\n  margin: 0 0 0.5rem 0;\n}\n\n.empty-state-card p {\n  margin: 0;\n  font-size: 0.875rem;\n}\n\n/* Detail Modal */\n.bulk-upload-detail-modal {\n  max-width: 800px;\n  max-height: 90vh;\n  overflow-y: auto;\n  border-radius: var(--radius-xl);\n}\n\n.bulk-upload-detail-modal .modal-header {\n  border-bottom: 1px solid var(--border-color);\n  padding: 1.25rem 1.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.bulk-upload-detail-modal .modal-title {\n  color: var(--text-main);\n  font-size: 1.25rem;\n  font-weight: 700;\n  margin: 0;\n}\n\n.bulk-upload-detail-modal .modal-close {\n  color: var(--text-sub);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--radius-md);\n  transition: all var(--transition-fast);\n}\n\n.bulk-upload-detail-modal .modal-close:hover {\n  background: var(--slate-100);\n  color: var(--text-main);\n}\n\n.bulk-upload-detail-modal .modal-body {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  padding: 1.5rem;\n}\n\n.detail-images {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.5rem;\n}\n\n.image-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.image-section label {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--text-sub);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.image-section img {\n  width: 120px;\n  height: 160px;\n  object-fit: cover;\n  border-radius: var(--radius-lg);\n  background: var(--slate-50);\n  border: 1px solid var(--border-color);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);\n}\n\n.detail-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.detail-info h3 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--text-main);\n  margin: 0;\n}\n\n.detail-info p {\n  font-size: 0.875rem;\n  color: var(--text-sub);\n  margin: 0;\n}\n\n.description-section {\n  margin-top: 0.5rem;\n}\n\n.description-section strong {\n  display: block;\n  font-size: 0.875rem;\n  color: var(--text-main);\n  margin-bottom: 0.5rem;\n}\n\n.description-section p {\n  line-height: 1.6;\n}\n\n.admin-comment-section {\n  background: var(--warning-bg);\n  border-left: 3px solid var(--warning-border);\n  padding: 1rem;\n  border-radius: var(--radius-md);\n}\n\n.admin-comment-section strong {\n  display: block;\n  color: var(--warning-text);\n  margin-bottom: 0.5rem;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.admin-comment-section p {\n  margin: 0;\n  color: var(--warning-text);\n  line-height: 1.5;\n}\n\n.bulk-upload-detail-modal .modal-actions {\n  display: flex;\n  flex-direction: row;\n  gap: 0.75rem;\n  padding: 1rem 1.5rem 1.5rem;\n  border-top: 1px solid var(--border-color);\n  justify-content: flex-end;\n  flex-shrink: 0;\n}\n\n.bulk-upload-detail-modal .modal-actions .btn {\n  white-space: nowrap;\n}\n\n/* Comment Modal */\n.comment-modal-overlay {\n  backdrop-filter: blur(4px);\n}\n\n.comment-modal {\n  border-radius: var(--radius-xl);\n  max-width: 500px;\n}\n\n.comment-modal .modal-header {\n  border-bottom: 1px solid var(--border-color);\n  padding: 1.25rem 1.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.comment-modal .modal-title {\n  color: var(--text-main);\n  font-size: 1.25rem;\n  font-weight: 700;\n  margin: 0;\n}\n\n.comment-modal .modal-close {\n  color: var(--text-sub);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--radius-md);\n  transition: all var(--transition-fast);\n}\n\n.comment-modal .modal-close:hover {\n  background: var(--slate-100);\n  color: var(--text-main);\n}\n\n.comment-modal .modal-body {\n  padding: 1.5rem;\n}\n\n.comment-modal .modal-message {\n  font-size: 0.9375rem;\n  color: var(--text-main);\n  margin-bottom: 1rem;\n}\n\n.comment-input-wrapper {\n  width: 100%;\n  margin-bottom: 1rem;\n}\n\n.comment-input-wrapper label {\n  display: block;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-main);\n  margin-bottom: 0.5rem;\n}\n\n.comment-input-wrapper .form-textarea {\n  width: 100%;\n}\n\n/* Edit Modal */\n.bulk-upload-edit-modal {\n  max-width: 600px;\n  max-height: 90vh;\n  overflow-y: auto;\n  border-radius: var(--radius-xl);\n}\n\n.bulk-upload-edit-modal .modal-header {\n  border-bottom: 1px solid var(--border-color);\n  padding: 1.25rem 1.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.bulk-upload-edit-modal .modal-title {\n  color: var(--text-main);\n  font-size: 1.25rem;\n  font-weight: 700;\n  margin: 0;\n}\n\n.bulk-upload-edit-modal .modal-close {\n  color: var(--text-sub);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--radius-md);\n  transition: all var(--transition-fast);\n}\n\n.bulk-upload-edit-modal .modal-close:hover {\n  background: var(--slate-100);\n  color: var(--text-main);\n}\n\n.bulk-upload-edit-modal .modal-body {\n  padding: 1.5rem;\n}\n\n.edit-form {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n}\n\n.edit-form .form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.edit-form .form-group.full-width {\n  grid-column: 1 / -1;\n}\n\n.edit-form .form-group label {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-main);\n}\n\n.edit-form .form-group .form-input,\n.edit-form .form-group .form-textarea {\n  width: 100%;\n  padding: 0.625rem 0.75rem;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-lg);\n  font-family: inherit;\n  font-size: 0.875rem;\n  transition: border-color 0.2s;\n  background-color: var(--surface-light);\n}\n\n.edit-form .form-group .form-input:focus,\n.edit-form .form-group .form-textarea:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px var(--primary-light);\n}\n\n.edit-form .form-group .form-textarea {\n  resize: vertical;\n  min-height: 100px;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .bulk-upload-page {\n    padding: 1rem;\n  }\n\n  .uploads-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .upload-images {\n    grid-template-columns: 1fr;\n  }\n\n  .detail-images {\n    grid-template-columns: 1fr;\n  }\n\n  .page-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .upload-card-actions {\n    justify-content: stretch;\n  }\n\n  .upload-card-actions .btn {\n    flex: 1;\n    justify-content: center;\n  }\n\n  .bulk-upload-detail-modal .modal-actions {\n    flex-direction: column;\n  }\n\n  .bulk-upload-detail-modal .modal-actions .btn {\n    width: 100%;\n  }\n\n  .filter-tabs {\n    width: 100%;\n  }\n\n  .filter-tab {\n    flex: 1;\n    text-align: center;\n  }\n\n  .page-header .page-title {\n    font-size: 1.5rem;\n  }\n}\n\n/* Pagination */\n.pagination-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n  padding: 1.5rem 0;\n  border-top: 1px solid var(--border-color);\n  margin-top: 1rem;\n}\n\n.pagination-info {\n  font-size: 0.875rem;\n  color: var(--text-sub);\n  margin: 0;\n}\n\n.pagination-info strong {\n  color: var(--text-main);\n  font-weight: 600;\n}\n\n.pagination-buttons {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.page-indicator {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-main);\n  padding: 0 1rem;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .pagination-container {\n    flex-direction: row;\n    justify-content: space-between;\n    flex-wrap: wrap;\n  }\n\n  .pagination-buttons {\n    flex: 1;\n    justify-content: center;\n  }\n\n  .page-indicator {\n    padding: 0 0.5rem;\n  }\n}\n\n/* Image Preview Modal */\n.image-preview-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.85);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 2rem;\n  animation: fade-in 0.2s ease-out;\n}\n\n@keyframes fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.image-preview-modal {\n  background: var(--surface);\n  border-radius: var(--radius-xl);\n  max-width: 90vw;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n}\n\n.image-preview-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1.5rem;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.image-preview-header h3 {\n  margin: 0;\n  font-size: 1.125rem;\n  color: var(--text-main);\n  font-weight: 600;\n}\n\n.image-preview-header .modal-close {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: var(--radius-md);\n  color: var(--text-sub);\n  transition: all var(--transition-fast);\n}\n\n.image-preview-header .modal-close:hover {\n  background: var(--slate-100);\n  color: var(--text-main);\n}\n\n.image-preview-content {\n  padding: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #000;\n  min-height: 400px;\n  max-height: 70vh;\n  overflow: auto;\n}\n\n.image-preview-content img {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n\n.image-preview-footer {\n  display: flex;\n  gap: 0.75rem;\n  padding: 1rem 1.5rem;\n  border-top: 1px solid var(--border-color);\n  background: var(--surface);\n}\n\n.image-preview-footer .btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n/* Zoom Controls */\n.zoom-controls {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.zoom-btn {\n  background: transparent;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: var(--text-sub);\n  transition: all var(--transition-fast);\n}\n\n.zoom-btn:hover {\n  background: var(--slate-100);\n  color: var(--text-main);\n  border-color: var(--slate-300);\n}\n\n.zoom-btn.reset {\n  margin-left: 0.5rem;\n}\n\n.zoom-level {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-main);\n  min-width: 50px;\n  text-align: center;\n}\n\n.image-preview-content img {\n  transition: transform 0.2s ease-out;\n  transform-origin: center center;\n}\n\n@media (max-width: 480px) {\n  .upload-card-actions .btn {\n    flex: 1 1 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
